import
  SkeletonBlock
from '@/app/ui/skeleton-block';

// Shown while the client-side campaign fetch in FeaturedCampaignSection is in
// flight, so the section doesn't just pop into existence once data arrives.
// Mirrors that component's real layout (label/heading/description, amount
// row, progress bar, CTA button) so there's no layout shift on swap-in, but
// is hand-rolled here rather than routed through SectionLayout/SectionHeader
// since those require a real heading string this state doesn't have yet.
export default function FeaturedCampaignSkeleton() {

  return (
    <section className="py-20 px-6 sm:px-8 bg-white dark:bg-gray-900">
      <div className="max-w-2xl mx-auto">
        <div className="mb-14 text-center space-y-3">
          <SkeletonBlock className="h-3 w-28 mx-auto" />
          <SkeletonBlock className="h-8 w-2/3 mx-auto" />
          <div className="space-y-2 pt-1">
            <SkeletonBlock className="h-4 w-full max-w-md mx-auto" />
            <SkeletonBlock className="h-4 w-5/6 max-w-sm mx-auto" />
          </div>
        </div>

        <div className="space-y-6">
          <div>
            <div className="flex items-baseline justify-between mb-2">
              <SkeletonBlock className="h-4 w-32" />
              <SkeletonBlock className="h-4 w-28" />
            </div>
            <SkeletonBlock className="h-3 w-full rounded-full" />
          </div>

          <div className="text-center">
            <SkeletonBlock className="h-12 w-56 mx-auto rounded-full" />
          </div>
        </div>
      </div>
    </section>
  );
}
